<template>
  <div class="card">
    <div class="card-body">
      <h2 class="card-title">Account Details</h2>

      <div class="row">
        <div class="col-lg-12">
          <validation-provider tag="div" class="mb-3" name="first name" vid="first_name" rules="required">
            <label>Name</label>
            <c-input type="text" v-model="stateName" />
            <c-help-block/>
          </validation-provider>
        </div>
        <div class="col-lg-6">
          <validation-provider tag="div" class="mb-3" name="email" rules="required|email">
            <label>Email</label>
            <c-input type="text" v-model="stateEmail" />
            <c-help-block/>
          </validation-provider>
        </div>
        <div class="col-lg-6">
          <div class="mb-3">
            <label>Access Level</label>
            <multiselect
              placeholder=""
              preselect-first
              :show-labels="false"
              :allow-empty="false"
              :options="[]"
              label="title"
            />
          </div>
        </div>
        <div class="col-lg-6">
          <div class="mb-3">
            <label>Account Status</label>
            <multiselect
              placeholder=""
              :preselect-first="true"
              :show-labels="false"
              :options="[]"
            />
          </div>
        </div>
      </div>

      <div>
        <slot/>
      </div>
    </div>
  </div>
</template>

<script>
import { stateMapper } from 'mixins/users'

export default {
  mixins: [stateMapper]
}
</script>
